import EquipmentMaterialTableApp from '../Functionality/EquipmentMaterialTableApp';
import CustomTable from '../../../../../components/table/CustomTable';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import routes from '../../../../../Routes/routes';
import DisplayView from '../../../../../components/DisplayView';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentAndMaterialTable = (props) => {
    const {
        selectForDelete,
        setSelectForDelete,
        isAllChecked,
        setIsAllChecked,
        setSearch,
        view,
        setBodyForExport,
        setView,
        setDeleteModalShow,
        modified,
        setModified,
        contractorId,
        supplierId,
    } = props;
    const {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        navigate,
        searchElement,
        option,
        page,
        rowsPerPage,
        setSimpleSearch,
        setSearchElement,
        setSearchResults,
    } = EquipmentMaterialTableApp({
        selectForDelete,
        setSelectForDelete,
        isAllChecked,
        setIsAllChecked,
        setDeleteModalShow,
        modified,
        setModified,
        setBodyForExport,
        contractorId,
    });
    return (
        <>
            <div className='d-flex pt-2'>
                <DisplayView view={view} setView={setView} className={''} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        setSearchResults={setSearchResults}
                    />
                </div>
            </div>
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={true}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                textNotInformation={'no_information'}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectForDelete}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                childrenNotInformation={
                    tbody?.data?.length === 0 ? (
                        <>
                            <div className={'warning-text'}>
                                <p>{t('you_haven_not_created_any_equipment_or_material')}</p>
                            </div>

                            <CustomButtonLink
                                splitName={false}
                                id={'btn_eamt_create'}
                                card={true}
                                onClick={() => navigate(routes.equipmentAndMaterial.create)}
                                name={'create_new_equipment_or_material'}
                            />
                        </>
                    ) : undefined
                }
            />
            {pagination()}
        </>
    );
};

export default EquipmentAndMaterialTable;
